import { DialogService, DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';
import { openWndown, print, search, getTotal } from '../../../../../shared/utils/utils';

export class DetailSerieBaseComponent {
  dialog: DynamicDialogComponent | undefined;
  print = print;
  openWindow = openWndown;
  search = search;
  getTotal = getTotal;

  constructor(
    public dialogRef: DynamicDialogRef,
    protected dialogService: DialogService,
  ) {
    this.dialog = this.dialogService.getInstance(this.dialogRef);
  }
}
